module.exports = __webpack_public_path__ + "static/media/YM78_4.96a23993.jpg";